"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MBDropdownMenu = exports.MBDropdownMenuItem = exports.IMBDropdownVariant = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var MBText_1 = require("../MBText");
var MBButton_1 = require("../MBButton");
var MBMenuPopover_1 = require("../MBMenuPopover");
var IMBDropdownVariant;
(function (IMBDropdownVariant) {
    IMBDropdownVariant[IMBDropdownVariant["medium"] = 0] = "medium";
    IMBDropdownVariant[IMBDropdownVariant["large"] = 1] = "large";
})(IMBDropdownVariant = exports.IMBDropdownVariant || (exports.IMBDropdownVariant = {}));
var MBDropdownMenuItem = function (_a) {
    var variant = _a.variant, icon = _a.icon, label = _a.label, onClick = _a.onClick, onClose = _a.onClose;
    var variantToUse = react_1.useMemo(function () {
        switch (variant) {
            case IMBDropdownVariant.medium:
                return 'body3';
            default:
                return 'body2';
        }
    }, [variant]);
    var paddingToUse = react_1.useMemo(function () {
        switch (variant) {
            case IMBDropdownVariant.medium:
                return '8px 10px';
            default:
                return '10px 8px';
        }
    }, [variant]);
    var handleClick = function () {
        if (onClick) {
            onClick();
            onClose && onClose();
        }
    };
    return (jsx_runtime_1.jsx(MBButton_1.MBButton, __assign({ padding: paddingToUse, width: "100%", border: "none", hoverVariant: MBButton_1.IMBButtonHoverVariant.darken, justifyContent: "flex-start" }, (icon && {
        Icon: {
            component: icon,
            position: 'left',
        },
    }), { onClick: handleClick }, { children: jsx_runtime_1.jsx(MBText_1.MBText, { variant: variantToUse, t: label }, void 0) }), void 0));
};
exports.MBDropdownMenuItem = MBDropdownMenuItem;
var MBDropdownMenu = function (_a) {
    var PopoverProps = _a.PopoverProps, items = _a.items, variant = _a.variant;
    var onClose = PopoverProps.onClose;
    return (jsx_runtime_1.jsx(MBMenuPopover_1.MBMenuPopover, __assign({}, PopoverProps, { children: items.map(function (item, i) {
            return (jsx_runtime_1.jsx(exports.MBDropdownMenuItem, __assign({}, item, { variant: variant, onClose: onClose }), i));
        }) }), void 0));
};
exports.MBDropdownMenu = MBDropdownMenu;
//# sourceMappingURL=MBDropdownMenu.js.map